// JS equivelent of ./styles/_grid.scss
export const forPhoneOnly = (innerWidth) => {
    if (typeof window != 'undefined') {
        const width = innerWidth || window.innerWidth;
        return width < 59;
    }
};
export const forTabletPortrait = (innerWidth) => {
    if (typeof window != 'undefined') {
        const width = innerWidth || window.innerWidth;
        return width >= 600;
    }
};
export const forTabletLandscape = (innerWidth) => {
    if (typeof window != 'undefined') {
        const width = innerWidth || window.innerWidth;
        return width >= 1200;
    }
};
export const forDesktop = (innerWidth) => {
    if (typeof window != 'undefined') {
        const width = innerWidth || window.innerWidth;
        return width >= 1600;
    }
};

// Calculate pattern angle
export const calculateAngle = (O, A) => {
    const convertToDeg = (rad) => (rad * 180) / Math.PI;
    const angle = Math.atan(O / A);
    return convertToDeg(angle);
};
